import intervalToDuration from "date-fns/intervalToDuration";

export function formatSeconds(seconds) {
  const duration = intervalToDuration({ start: 0, end: seconds * 1000 });
  return `${duration.hours.toString().padStart(2, "0")}:${duration.minutes.toString().padStart(2, "0")}:${duration.seconds.toString().padStart(2, "0")}`;
}
